export const Config = {
  apiUrl: "http://18.177.199.76/api/"
};
